import restUtils from "core/utils/rest";
import { RiskRatingResult, riskRatingResultTransformer } from "./transformers/riskRating";

export const getInvestorRiskRating = (investorId: string): Promise<RiskRatingResult[]> => {
  const url = `hubwise-api/aml/investor/${investorId}/risk-results`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map(riskRatingResultTransformer).sort((a: RiskRatingResult, b: RiskRatingResult) => {
      return b.calculatedRiskRatingDate - a.calculatedRiskRatingDate;
    });
  });
};

export const getInvestorRiskEngineLink = (investorId: string): Promise<string> => {
  const url = `hubwise-api/aml/investor/${investorId}/risk-engine-link`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.payload;
  });
};


export const requestManualRiskEngineAssessments = (investorId: string): Promise<void> => {
  const url = `hubwise-api/aml/investor/${investorId}/riskEngine-requests`;
  const body = { };
  return restUtils.call("PortalApi", url, "POST", body).then(() => {
    return;
  });
};

export const getInvestorRiskEngineRequests = (investorId: string): Promise<any[]> => {
  const url = `hubwise-api/aml/investor/${investorId}/riskEngine-requests`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows;
  });
};
